import { type Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

export const apiScope = import.meta.env.VITE_API_SCOPE;

if (!tenantId || !clientId || !apiScope) {
  // Crash loudly in the console so a misconfigured deploy is obvious.
  console.error(
    'Missing MSAL env vars. Required: VITE_ENTRA_TENANT_ID, VITE_ENTRA_CLIENT_ID, VITE_API_SCOPE',
  );
}

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error(`[MSAL] ${message}`);
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Scopes we request at sign-in. User.Read gives us basic profile for the header;
// apiScope mints an access token the SPA attaches to /api/updates calls.
export const loginRequest = {
  scopes: ['User.Read', apiScope],
};

// Scopes for acquiring a token for API calls specifically.
export const apiTokenRequest = {
  scopes: [apiScope],
};
